package music.limasoul.client.shared.user.di

import music.limasoul.client.shared.user.data.repository.UserRepositoryImpl
import music.limasoul.client.shared.user.domain.repository.UserRepository
import music.limasoul.client.shared.user.domain.usecase.GetCurrentUserUseCase
import music.limasoul.client.shared.user.domain.usecase.GetUserUseCase
import org.koin.dsl.module

val userSharedModule = module {

    factory {
        GetUserUseCase(
            userRepository = get(),
        )
    }

    factory {
        GetCurrentUserUseCase(
            userRepository = get(),
        )
    }

    single<UserRepository> {
        UserRepositoryImpl(
            settings = get(),
            client = get(),
        )
    }
}